/**
 * @fileoverview Module for `src/dashboard/manage-letters/EmptyColumn.js`.
 */

import PropTypes from 'prop-types';

const messageByStatus = {
  UNPREPPED: 'You have no unprepared letters.',
  PREPPED: 'You have no prepared letters.',
  SENT: "You haven't sent any letters yet.",
};

/**
 * Empty-state message shown when a manage letters column has no results.
 *
 * @param {Object} params
 * @returns {JSX.Element} Empty status message.
 */
function EmptyColumn({ letterFilterPresent, status }) {
  return (
    <div className='empty-letter-column mb-4 h5 text-gray'>
      { letterFilterPresent ? 'No results' : messageByStatus[status] }
    </div>
  );
}

EmptyColumn.propTypes = {
  letterFilterPresent: PropTypes.bool.isRequired,
  status: PropTypes.string.isRequired,
};

export default EmptyColumn;
